module.exports = __webpack_public_path__ + "static/media/pdf.be584784.svg";